import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { NextButton } from '../NextButton/NextButton'
import { SettingsButton } from '../SettingsButton/SettingsButton'
import { getIsLangRu } from '../../store/langSlice'
import { getIsSafari } from '../../store/commonSlice'
import { getNextScreen, goNextScreen } from '../../store/screenSlice'

import { ChromeVideo } from './ChromeVideo/ChromeVideo'
import { SafariVideo } from './SafariVideo/SafariVideo'


class VideoScreenBody extends Component {
    constructor(props, context) {
        super(props, context)

        const { isSafari, isLangRu, srcVideo, srcVideoRu, srcVideoTt, srcAudioRu, srcAudioTt } = props

        if (isSafari) {
            this.videoSrc = srcVideo
            this.audioSrc = isLangRu ? srcAudioRu : srcAudioTt
        } else {
            this.videoSrc = isLangRu ? srcVideoRu : srcVideoTt
        }
    }

    onTimeUpdateHandler = (videoEl) => {
        const { onTimeUpdate, nextScreen, goNextScreen } = this.props

        if (nextScreen) {
            return
        }

        if ((videoEl.currentTime + 1) > videoEl.duration) {
            goNextScreen()
        }

        if (onTimeUpdate) {
            onTimeUpdate(videoEl)
        }
    }

    render() {
        const { isSafari, isVisible } = this.props

        return (
            <>
                {
                    isSafari
                        ? (
                            <SafariVideo
                                playing={isVisible}
                                videoSrc={this.videoSrc}
                                audioSrc={this.audioSrc}
                                onTimeUpdate={this.onTimeUpdateHandler}
                            />
                        )
                        : (
                            <ChromeVideo
                                playing={isVisible}
                                videoSrc={this.videoSrc}
                                onTimeUpdate={this.onTimeUpdateHandler}
                            />
                        )
                }
                <SettingsButton isVisible={isVisible} />
                <NextButton />
            </>
        )
    }
}

VideoScreenBody.propTypes = {
    isSafari: PropTypes.bool.isRequired,
    isLangRu: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    nextScreen: PropTypes.string,
    goNextScreen: PropTypes.func.isRequired,
    onTimeUpdate: PropTypes.func,

    srcVideo: PropTypes.string.isRequired,
    srcVideoRu: PropTypes.string.isRequired,
    srcVideoTt: PropTypes.string.isRequired,
    srcAudioRu: PropTypes.string.isRequired,
    srcAudioTt: PropTypes.string.isRequired,
}

const VideoScreen = connect(
    state => ({
        isSafari: getIsSafari(state),
        isLangRu: getIsLangRu(state),
        nextScreen: getNextScreen(state),
    }), {
        goNextScreen,
    },
)(VideoScreenBody)

VideoScreen.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    onTimeUpdate: PropTypes.func,

    srcVideo: PropTypes.string.isRequired,
    srcVideoRu: PropTypes.string.isRequired,
    srcVideoTt: PropTypes.string.isRequired,
    srcAudioRu: PropTypes.string.isRequired,
    srcAudioTt: PropTypes.string.isRequired,
}

export { VideoScreen }
